<template>
  <div>
    <question-renderer
      :question="src"
      :indicator="indicator"
    ></question-renderer>

    <div class="wysiwyg-content" id="choices-block">
      <v-window v-model="window" touchless>
        <v-window-item :key="`window_0`">
          <v-card flat>
            <!-- <v-toolbar flat dense>
                <span
                  class="subtitle-1 font-weight-bold"
                >รายการโจทย์ (กด/เลือก โจทย์ที่ต้องการจับคู่)</span>
            </v-toolbar>-->
            <v-list dense>
              <!-- <v-list-item-group v-model="selected" active-class="green--text"> -->
              <v-list-item-group v-model="selected">
                <template v-for="(item, idx) in src.questionMatch">
                  <!-- <v-divider :key="`divider_qmatch_${idx}_l`"></v-divider> -->
                  <v-list-item
                    :key="`qmatch_${idx}`"
                    @click="showRight(idx)"
                    :value="idx"
                    class="no-padding answer-pair"
                  >
                    <v-list-item-content>
                      <div v-html="item"></div>
                      <!-- <div
                          class="mt-2"
                          v-if="answer.length > 0 && answer[idx].correct.length > 0"
                        >
                          จับคู่ :
                          <template v-for="(myMatch, idx) of answer[idx].correct">
                            <v-avatar
                              size="24"
                              color="grey"
                              class="mr-1 white--text body-2"
                              :key="`myMatch_${idx}`"
                            >{{ getAnswerIndex(myMatch) }}</v-avatar>
                          </template>
                      </div>-->
                      <!-- <div v-if="showCorrectAnswer">
                          เฉลย :
                          <template
                            v-for="(correctMatch, idx) of correctAnswer.correctMatch[idx].correct"
                          >
                            <v-avatar
                              size="24"
                              color="success"
                              class="mr-1 white--text body-2"
                              :key="`correctMatch_${idx}`"
                            >{{ getAnswerIndex(correctMatch._id) }}</v-avatar>
                          </template>
                      </div>-->
                    </v-list-item-content>
                    <v-list-item-action>
                      <template v-if="!showCorrectAnswer">
                        <!-- <v-icon
                            v-if="answer[idx] && answer[idx].correct.length > 0"
                            small
                            color="primary"
                        >far fa-project-diagram</v-icon>-->
                        <v-btn
                          v-if="answer[idx] && answer[idx].correct.length > 0"
                          class="ma-2"
                          outlined
                          >แก้ไข</v-btn
                        >
                        <v-btn v-else class="ma-2" outlined>
                          <span>เลือกคู่</span>
                          <v-icon small color="#787978" class="arrow-select"
                            >far fa-chevron-right</v-icon
                          >
                        </v-btn>
                      </template>
                      <template v-if="showCorrectAnswer">
                        <v-icon
                          small
                          :color="isValid(idx) ? 'success' : 'error'"
                          >far
                          {{ isValid(idx) ? "fa-check" : "fa-times" }}</v-icon
                        >
                      </template>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider :key="`divider_qmatch_${idx}_l`"></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-window-item>
        <v-window-item :key="`window_1`">
          <v-card flat>
            <div
              v-html="src.questionMatch[selected]"
              class="question-pair"
            ></div>
            <v-toolbar flat class="choice-description">
              <!-- <div :v-html="src.questionMatch[selected]"></div> -->
              <!-- <v-btn icon @click="cancelSelect">
                  <v-icon small color="primary">far fa-arrow-left</v-icon>
              </v-btn>-->
              <span
                class="subtitle-match font-weight-bold"
                v-if="showCorrectAnswer"
                >คำตอบที่เลือก</span
              >
              <span class="subtitle-match font-weight-bold" v-else
                >เลือกคู่ของคำตอบด้านบน (สามารถเลือกได้มากกว่า 1)</span
              >
              <v-spacer></v-spacer>
              <!-- <v-btn text color="primary" @click="saveChoice" v-show="!readOnly">
                  <v-icon left>far fa-save</v-icon>บันทึก
              </v-btn>-->
            </v-toolbar>
            <v-list dense :disabled="readOnly">
              <!-- <v-list-item-group multiple v-model="selectedRight" @change="saveChoice" active-class="green--text"> -->
              <v-list-item-group
                multiple
                v-model="selectedRight"
                @change="saveChoice"
              >
                <template v-for="(item, idx) in src.choices">
                  <!-- <v-divider :key="`divider_qmatch_${idx}_r`"></v-divider> -->
                  <v-list-item
                    :key="`qmatch_${idx}`"
                    :value="item._id"
                    class="answer-pair no-padding"
                  >
                    <template v-slot:default="{ active }">
                      <!-- <v-list-item-avatar color="grey" size="24">
                          <v-avatar class="white--text body-2">{{ idx+1 }}</v-avatar>
                      </v-list-item-avatar>-->
                      <v-list-item-content
                        v-html="item.text"
                      ></v-list-item-content>
                      <v-list-item-action>
                        <!-- <v-icon v-if="active" small color="primary">far fa-project-diagram</v-icon> -->
                        <v-icon v-if="active" small color="primary"
                          >far fa-check-square</v-icon
                        >
                        <v-icon v-else small color="primary"
                          >far fa-square</v-icon
                        >
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider :key="`divider_qmatch_${idx}_r`"></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
            <div class="btn-back">
              <v-btn class="ma-2" color="primary" @click="cancelSelect">
                <v-icon small class="arrow-select-left"
                  >far fa-chevron-left</v-icon
                >
                <span>ย้อนกลับ</span>
              </v-btn>
            </div>
          </v-card>
        </v-window-item>
      </v-window>
    </div>

    <!-- <v-expand-transition>
        <div
          v-if="showCorrectAnswer && correctAnswer.note != null && correctAnswer.note != ''"
          class="mt-4"
        >
          <v-alert text type="info" :icon="false">
            <div class="subtitle-1 font-weight-bold">
              <v-icon color="info" left>far fa-info-circle</v-icon>เพิ่มเติม
            </div>
            <v-divider class="my-3 info" style="opacity:.2"></v-divider>
            <div v-html="correctAnswer.note"></div>
          </v-alert>
        </div>
    </v-expand-transition>-->
    <v-expand-transition>
      <div v-if="showCorrectAnswer && selected !== null" class="mt-4">
        <div class="subtitle-1 font-weight-bold">คำตอบที่ถูกต้อง</div>
        <v-card class="my-3" v-if="selected != null">
          <v-list dense>
            <template
              v-for="(item, idx) of correctAnswer.correctMatch[selected]
                .correct"
            >
              <v-divider
                v-show="idx > 0"
                :key="`divider_correctAns_${idx}`"
              ></v-divider>
              <v-list-item :key="`correctAns_${idx}`">
                <v-list-item-content>
                  <div v-html="getAnswerText(item._id)"></div>
                </v-list-item-content>
                <!-- <v-list-item-action>
                    <v-icon small color="success">far fa-check</v-icon>
                </v-list-item-action>-->
              </v-list-item>
            </template>
          </v-list>
        </v-card>
        <v-alert
          text
          type="info"
          :icon="false"
          v-if="correctAnswer.note != null && correctAnswer.note != ''"
        >
          <div class="subtitle-1 font-weight-bold">
            <v-icon color="info" left>far fa-info-circle</v-icon>เพิ่มเติม
          </div>
          <v-divider class="my-3 info" style="opacity: 0.2"></v-divider>
          <div v-html="correctAnswer.note"></div>
        </v-alert>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  name: "MatchingExam",
  props: ["src", "userAnswer", "correctAnswer", "indicator"],
  data: () => ({
    window: 0,
    selected: null,
    selectedRight: [],
    answer: [],
  }),
  components: {
    QuestionRenderer,
  },

  computed: {
    showCorrectAnswer() {
      if (
        this.correctAnswer != null &&
        this.correctAnswer.correctMatch.length != 0
      ) {
        this.$nextTick(() => {
          if (this.$store.state.showCorrectAnswer == false) {
            this.$vuetify.goTo("#choices-block");
          }
        });
        return true;
      }
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  watch: {
    answer: {
      deep: true,
      handler(val) {
        // precheck is empty state
        let empty = true;
        for (let item of val) {
          if (item.correct.length > 0) {
            empty = false;
            break;
          }
        }
        const data = {
          answer: empty ? null : val,
        };
        this.$emit("interact", data);
      },
    },
    // selectedRight(oldVal,newVal){
    //   // console.log(this.readOnly)
    //   console.log(oldVal)
    //   // if(oldVal!==newVal){
    //     if(!this.$store.state.readOnly){
    //       this.saveChoice()
    //     }
    //   // }
    // }
    selected(val) {
      console.log(val);
    },
  },
  mounted() {
    this.answer = [];
    this.selectedRight = [];
    this.selected = null;

    this.init();
  },
  methods: {
    isValid(idx) {
      console.log(idx)
      console.log(this.answer[idx].correct)
      console.log(this.correctAnswer.correctMatch[idx].correct)
      return this.$matchsomeIsMatched(
        this.answer[idx].correct,
        this.correctAnswer.correctMatch[idx].correct
      );
    },
    getAnswerIndex(id) {
      return this.src.choices.findIndex((x) => x._id == id) + 1;
    },
    getAnswerText(id) {
      console.log(id);
      return this.src.choices.filter((x) => x._id == id)[0].text;
    },
    setColor(value) {
      if (this.showCorrectAnswer === true) {
        console.log(
          value,
          this.correctAnswer.correctMatch.findIndex((x) => x == value)
        );
        if (
          this.correctAnswer.correctMatch.findIndex((x) => x == value) != -1
        ) {
          return "success";
        } else {
          return "error";
        }
      }
      return "primary";
    },
    init() {
      // default answer to empty
      for (let i = 0; i < this.src.questionMatch.length; i++) {
        this.answer.push({
          correct: [],
        });
      }

      if (this.userAnswer != null) {
        for (let i = 0; i < this.answer.length; i++) {
          this.answer[i].correct = this.userAnswer[i].correct.map((x) => x);
        }
      }
    },
    getAnswer() {
      this.cancelSelect();
      return this.answer;
    },
    showRight(idx) {
      // this.selected = idx;
      this.window = 1;
      this.$nextTick(() => {
        this.selectedRight = this.answer[this.selected].correct;
      });
    },
    cancelSelect() {
      this.window = 0;
      this.$nextTick(() => {
        this.selectedRight = [];
        this.selected = null;
      });
    },
    saveChoice() {
      const tmp = this.selectedRight.map((x) => x);
      this.answer[this.selected].correct = tmp == null ? [] : tmp;
      // this.cancelSelect();
    },
  },
};
</script>

<style scoped>
.arrow-select {
  margin-left: 10px;
}
.arrow-select-left {
  margin-right: 10px;
}
.question-pair {
  background-color: #f0f1f0;
  padding: 20px;
}
.subtitle-match {
  font-size: 14px !important;
  font-weight: 400;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Roboto", sans-serif !important;
  margin-top: 40px;
}
.btn-back {
  text-align: center;
}
.answer-pair {
  min-height: 76px;
}
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0;
}
/* .v-list-item {
    padding: 0;
} */
.no-padding {
  padding: 0;
}
/* .v-toolbar__content{

} */
</style>
<style>
.choice-description.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--flat
  > .v-toolbar__content {
  padding: 0;
}
</style>